<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>

        <el-breadcrumb-item> 考级测试</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="warning" class="elalert">
        1.请根据自己的身份选择不同的考试类型<br />
        2.游客身份可以测试客观题，不可以测试实践题。<br />
        3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。<br />
      </el-alert>

      <el-steps
        :space="200"
        :active="2"
        finish-status="success"
        class="elsteps"
      >
        <el-step title="报名信息"></el-step>
        <el-step title="理论测试"></el-step>
        <el-step title="实践考试"></el-step>
        <el-step title="考级结果"></el-step>
        <el-step title="查看证书"></el-step>
      </el-steps>

      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_content">
            <div class="container_left_content_img">
              <img :src="row.user.face" />
            </div>
            <div class="container_left_content_name">
              <span>姓名：</span>{{ row.user.name }}
            </div>
            <div class="container_left_content_name">
              <span>实践题：</span> {{ row.shijian_question.title }}
            </div>
            <!-- <div class="container_left_content_serve">
              <i class="el-icon-service"></i>
              <a
                @click="serviceCustomerClickFun()"
                :style="{ color: '#1981ff' }"
                >联系客服</a
              >
            </div> -->
          </div>
        </div>
        <div class="container_center">
          <!--          <div>{{row.shijian_question.title}}</div>-->
          <el-upload
            class="upload-demo"
            drag
            v-if="row.shijian_question.file_type == 1"
            action=""
            accept=".mp4,.mov"
            :http-request="uploadFile"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将视频文件拖到此处，或<em>点击上传</em>
            </div>
            <div
              class="el-upload__tip html-data"
              slot="tip"
              v-html="row.shijian_question.desc_html"
            ></div>
          </el-upload>
          <el-upload
            class="upload-demo"
            drag
            v-else-if="row.shijian_question.file_type == 2"
            action=""
            accept=".doc,.docx"
            :http-request="uploadFile"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将word文件拖到此处，或<em>点击上传</em>
            </div>
            <div
              class="el-upload__tip html-data"
              slot="tip"
              v-html="row.shijian_question.desc_html"
            ></div>
          </el-upload>
          <el-upload
            class="upload-demo"
            drag
            v-else-if="row.shijian_question.file_type == 3"
            action=""
            accept=".jpg,.png"
            :http-request="uploadFile"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将图片文件拖到此处，或<em>点击上传</em>
            </div>
            <div
              class="el-upload__tip html-data"
              slot="tip"
              v-html="row.shijian_question.desc_html"
            ></div>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import NewsListItem from "@/components/listItem/NewsListItem";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      ossAccessTokenURL: "https://api.dierqudao.com/core/attachment/aliOssSts",
      ossFileURL: "https://cheeseman.oss-cn-hangzhou.aliyuncs.com",
      fileList: [],
      row: {
        id: 0,
        user: {},
        kaoji: {},
        shijian_question: {},
      },
      cert: {},
    };
  },
  components: {
    NewsListItem,
  },
  computed: {},
  mounted() {
    let that = this;
    that.row.id = this.$route.query.id || 0;
    if (that.row.id) {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post(
        "/api/kaoji/step5Detail",
        {
          id: that.row.id,
        },
        (res) => {
          that.row = res.data;
        }
      );
    },
    getNowFormatDate: function () {
      var date = new Date();
      var seperator1 = "";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return year + seperator1 + month + seperator1 + strDate;
    },
    uploadFile(evt) {
      var that = this;
      console.log(that.ossFileURL);
      evt.onProgress({ percent: 0 });
      OSS.urllib.request(
        this.ossAccessTokenURL,
        { method: "GET" },
        function (err, response) {
          let result;
          if (err) {
            that.$message("上传异常:" + err);
            console && console.error(err);
            evt.onError(100);
            return;
          }
          try {
            result = JSON.parse(response);
          } catch (e) {
            return alert("parse sts response info error: " + e.message);
          }
          var client = new OSS.Wrapper({
            accessKeyId: result.data.AccessKeyId,
            accessKeySecret: result.data.AccessKeySecret,
            stsToken: result.data.SecurityToken,
            endpoint: result.data.endpoint,
            bucket: result.data.bucket,
            secure: true,
          });
          var suffix = evt.file.name.toLowerCase().split(".").splice(-1)[0];
          console.log(that.ossFileURL);
          var myDate = new Date();
          var file_save_name =
            "uploader/" +
            that.getNowFormatDate() +
            "/user-" +
            that.row.user.id +
            "/" +
            evt.file.uid +
            "." +
            suffix;
          console.log(file_save_name);
          client
            .multipartUpload(file_save_name, evt.file)
            .then(function (result) {
              evt.onSuccess();
              console.log(that.ossFileURL);
              var file = {
                url: that.ossFileURL + "/" + file_save_name,
                name: evt.file.name,
                uid: evt.file.uid,
                save_name: file_save_name,
              };
              evt.onProgress({
                percent: 100,
                type: "success",
              });
              that.$message({
                message: evt.file.name + "上传成功",
                type: "success",
              });

              that.$api.post(
                "/api/kaoji/step5save",
                {
                  id: that.row.id,
                  file: [file],
                },
                (r) => {
                  that.$message.success("上传成功");
                  that.$router.push({
                    name: "KaojiApplyStep6",
                    query: {
                      id: that.row.id,
                    },
                  });
                }
              );
            })
            .catch(function (err) {
              evt.onError();
              that.$message({
                message: evt.file.name + "上传失败",
                type: "warning",
              });
            });
        }
      );
    },
  },
};
</script>
<style scoped lang="scss">
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    .container_left_content {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      margin: 88px 0 0 0;
      overflow: hidden;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        outline: none;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        // padding-left: 65px;
        margin-bottom: 9px;
        box-sizing: border-box;
        width: 108px;
        white-space: wrap;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        width: 108px;
        display: flex;
        flex-direction: row;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        margin-top: 8px;
        // padding-left: 65px;
        box-sizing: border-box;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 1000px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container_right {
    width: 296px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// KaojiApplyStep5.vue?295f4552